function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { GRID_STRING_COL_DEF } from "./gridStringColDef.js";
import { GRID_NUMERIC_COL_DEF } from "./gridNumericColDef.js";
import { GRID_DATE_COL_DEF, GRID_DATETIME_COL_DEF } from "./gridDateColDef.js";
import { GRID_BOOLEAN_COL_DEF } from "./gridBooleanColDef.js";
import { GRID_SINGLE_SELECT_COL_DEF } from "./gridSingleSelectColDef.js";
import { GRID_ACTIONS_COL_DEF, GRID_ACTIONS_COLUMN_TYPE } from "./gridActionsColDef.js";
export var DEFAULT_GRID_COL_TYPE_KEY = 'string';
export var getGridDefaultColumnTypes = function() {
    var _obj;
    var nativeColumnTypes = (_obj = {
        string: GRID_STRING_COL_DEF,
        number: GRID_NUMERIC_COL_DEF,
        date: GRID_DATE_COL_DEF,
        dateTime: GRID_DATETIME_COL_DEF,
        boolean: GRID_BOOLEAN_COL_DEF,
        singleSelect: GRID_SINGLE_SELECT_COL_DEF
    }, _define_property(_obj, GRID_ACTIONS_COLUMN_TYPE, GRID_ACTIONS_COL_DEF), _define_property(_obj, "custom", GRID_STRING_COL_DEF), _obj);
    return nativeColumnTypes;
};
